/* eslint-disable import/no-unresolved */
// eslint-disable-next-line import/no-unresolved
import Resources from "src/config/Resources";
import { PRODUCT_ID } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { useAppSelector } from "src/utils/hooks/useAppSelector";

interface Props {
  label: string;
}

function DetailsHeading({ label }: Props) {
  const clcApplicationNo = useAppSelector((state) => state.common?.leadDetails?.clcAppNo) || "";
  const productId = useAppSelector((state) => state.common.productId);
  const loanAccountNo = useAppSelector((state) => state.common?.leadDetails?.loanAccountNo);
  const loanDetails = useAppSelector((state) => state.loanDetails.loan.loanAcNo);
  return (
    <div className="flex items-center">
      <img
        className="h-9.5 w-9 mr-5.5"
        src={Resources.images.FormDetails.generalDetailsIcon}
        alt="generalDetailsIcon"
      />
      <div className="font-montserrat md:text-xl text-black flex flex-col md:flex-row py-2">
        <p className="font-bold text-xl">{label}</p>
        <p className="font-bold hidden md:block">&nbsp; | &nbsp;</p>
        <p className="font-medium text-sm md:text-xl">CLC Application No. - {clcApplicationNo}</p>
        {[PRODUCT_ID.GHS, PRODUCT_ID.GHS_FOR_JIO, PRODUCT_ID.GHS_IDBI]?.includes(productId!) && (
          <>
            <p className="font-bold hidden md:block">&nbsp; | &nbsp;</p>
            <p className="font-medium text-sm md:text-xl">
              Loan Account No. - {loanDetails || loanAccountNo || ""}
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default DetailsHeading;
